'use strict';Object.defineProperty(exports,'__esModule',{value:!0});var _InformationField=require('./InformationField'),_InformationField2=_interopRequireDefault(_InformationField);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}exports.default=_InformationField2.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/form-components/lib/InformationField/index.js
// module id = 60
// module chunks = 0